import React from "react";

export type LoadingOverlayProps = {
  className?: string;
  children?: React.ReactNode;
};

export const LoadingOverlay = ({ className = "", children, ...props }: LoadingOverlayProps) => (
  <span className={`loading-overlay ${className}`} {...props}>
    {children ?? null}
  </span>
);
